import { useClientConfigModelStore } from '@/models/client-config/clientConfig';
import { useEnvConfigModelStore } from '@/models/env-config/envConfig';
import React from 'react';

export default function useAppApiServerHostnames() {
  const apiBaseUrl = useClientConfigModelStore((state) => state.apiBaseUrl);
  const appApiServerHostnames = useEnvConfigModelStore((x) => x.APP_API_SERVER_HOSTNAMES);

  const listString = React.useMemo(() => {
    const list = new Set(appApiServerHostnames);
    if (apiBaseUrl) {
      try {
        const url = new URL(apiBaseUrl);
        list.add(url.hostname);
      } catch (_error) {
        if (_error) {
          //
        }
      }
    }

    return JSON.stringify([...list]);
  }, [appApiServerHostnames, apiBaseUrl]);
  const result = React.useMemo<string[]>(() => {
    return JSON.parse(listString);
  }, [listString]);

  return result;
}
